<template>
	<div class="recent-transactions-section" v-if="limitedTransactions && limitedTransactions.length > 0">
		<h3 class="section-title">{{ accountTypeTitle }} transactions</h3>
		<TransactionsList
			:transactions="limitedTransactions"
			:formatter="formatter"
			:today="today"
			:yesterday="yesterday"
			:showDate="true"
			:showDateTotal="false"
			:search="false"
			:dividingLines="true"
			:dateCounts="dateCounts"
		/>
		<v-divider></v-divider>
		<div class="view-more" @click="handleViewMore">
			View more <img class="arrow" :src="require('@/assets/arrow-right.png')" />
		</div>
	</div>
</template>

<script>
import TransactionsList from './TransactionsList.vue';

export default {
	name: 'RecentTransactionsSection',
	emits: ['view-more'],
	components: {
		TransactionsList
	},
	props: {
		transactions: {
			type: Array,
			required: true
		},
		formatter: {
			type: Object,
			required: true
		},
		today: {
			type: String,
			required: true
		},
		yesterday: {
			type: String,
			required: true
		},
		accountType: {
			type: String,
			required: true
		},
		accountIds: {
			type: Array,
			required: true
		}
	},
	computed: {
		accountTypeTitle() {
			const titles = {
				'all': 'Recent',
				'current': 'Current Account',
				'credit': 'Credit Card',
				'savings': 'Savings Account'
			};
			return titles[this.accountType] || 'Recent';
		},
		dateCounts() {
			if (!this.transactions || this.transactions.length === 0 || !this.accountIds || this.accountIds.length === 0) {
				return {};
			}

			const counts = {};
			for (const group of this.transactions) {
				if (group.length === 0) continue;

				const dateString = group[0].timestampString;
				let count = 0;

				for (const transaction of group) {
					if (this.accountIds.includes(transaction.bankAccountID)) {
						count++;
					}
				}

				if (count > 0) {
					counts[dateString] = count;
				}
			}

			return counts;
		},
		limitedTransactions() {
			if (!this.transactions || this.transactions.length === 0 || !this.accountIds || this.accountIds.length === 0) {
				return [];
			}

			// Filter by account IDs and limit to first 3 transactions
			let count = 0;
			const limited = [];

			for (const group of this.transactions) {
				const groupTransactions = [];
				for (const transaction of group) {
					// Only include transactions from the selected account type
					if (this.accountIds.includes(transaction.bankAccountID)) {
						if (count < 3) {
							groupTransactions.push(transaction);
							count++;
						} else {
							break;
						}
					}
				}
				if (groupTransactions.length > 0) {
					limited.push(groupTransactions);
				}
				if (count >= 3) {
					break;
				}
			}

			return limited;
		}
	},
	methods: {
		handleViewMore() {
			this.$emit('view-more');
		}
	}
}
</script>

<style scoped>
.recent-transactions-section {
	background: white;
	border-radius: 8px;
	margin: 24px 0;
	box-shadow: 0px 2px 4px 0px rgba(51, 40, 71, 0.05);
	overflow: hidden;
}

.section-title {
	font-size: 15px;
	font-weight: bold;
	margin-bottom: -8px;
	margin-top: 16px;
	padding: 0 20px;
	text-align: center;	
}

.view-more {
	text-align: center;
	font-size: 13px;
	padding: 12px 20px;
}

:deep(.transactions-list) {
	padding-top: 0;
	padding-bottom: 0;
}

.arrow {
	width: 12px;
	height: 7.5px;
	margin-left: 6px;
	vertical-align: middle;
}
</style>
